import React from 'react';
import {
    ChevronLeftIcon,
    ChevronRightIcon,
    DoubleArrowLeftIcon,
    DoubleArrowRightIcon,
} from '@radix-ui/react-icons';
import { Table } from '@tanstack/react-table';

import { Button } from '../Button';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '../Select';

import './styles.scss';

interface DataTablePaginationProps<TData> {
    table: Table<TData>;
}

export function DataTablePagination<TData>({
    table,
}: DataTablePaginationProps<TData>) {
    return (
        <div className='data-table-pagination'>
            <div className='data-table-pagination__selected'>
                {/* {table.getFilteredSelectedRowModel().rows.length} of{' '}
                {table.getFilteredRowModel().rows.length} row(s) selected. */}
            </div>
            <div className='data-table-pagination__wrapper'>
                <div className='data-table-pagination__wrapper__rowsperpage'>
                    <p className='data-table-pagination__wrapper__rowsperpage__label'>
                        Rows per page
                    </p>
                    <Select
                        value={`${table.getState().pagination.pageSize}`}
                        onValueChange={value => {
                            table.setPageSize(Number(value));
                        }}
                    >
                        <SelectTrigger className='data-table-pagination__wrapper-select'>
                            <SelectValue
                                placeholder={
                                    table.getState().pagination.pageSize
                                }
                            />
                        </SelectTrigger>
                        <SelectContent side='top'>
                            {[10, 20, 30, 40, 50].map(pageSize => (
                                <SelectItem
                                    key={pageSize}
                                    value={`${pageSize}`}
                                >
                                    {pageSize}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
                <div className='data-table-pagination__wrapper__page'>
                    Page {table.getState().pagination.pageIndex + 1} of{' '}
                    {table.getPageCount()}
                </div>
                <div className='data-table-pagination__wrapper__buttons'>
                    <Button
                        variant='outline'
                        className='data-table-pagination__wrapper__buttons__firstpage'
                        onClick={() => table.setPageIndex(0)}
                        disabled={!table.getCanPreviousPage()}
                    >
                        <span className='data-table-pagination__wrapper__buttons__firstpage__label'>
                            Go to first page
                        </span>
                        <DoubleArrowLeftIcon className='data-table-pagination__wrapper__buttons__firstpage__icon' />
                    </Button>
                    <Button
                        variant='outline'
                        className='data-table-pagination__wrapper__buttons__previouspage'
                        onClick={() => table.previousPage()}
                        disabled={!table.getCanPreviousPage()}
                    >
                        <span className='data-table-pagination__wrapper__buttons__previouspage__label'>
                            Go to previous page
                        </span>
                        <ChevronLeftIcon className='data-table-pagination__wrapper__buttons__previouspage__icon' />
                    </Button>
                    <Button
                        variant='outline'
                        className='data-table-pagination__wrapper__buttons__previouspage'
                        onClick={() => table.nextPage()}
                        disabled={!table.getCanNextPage()}
                    >
                        <span className='data-table-pagination__wrapper__buttons__previouspage__label'>
                            Go to next page
                        </span>
                        <ChevronRightIcon className='data-table-pagination__wrapper__buttons__previouspage__icon' />
                    </Button>
                    <Button
                        variant='outline'
                        className='data-table-pagination__wrapper__buttons__firstpage'
                        onClick={() =>
                            table.setPageIndex(table.getPageCount() - 1)
                        }
                        disabled={!table.getCanNextPage()}
                    >
                        <span className='data-table-pagination__wrapper__buttons__firstpage__label'>
                            Go to last page
                        </span>
                        <DoubleArrowRightIcon className='data-table-pagination__wrapper__buttons__firstpage__icon' />
                    </Button>
                </div>
            </div>
        </div>
    );
}
